import Cookie from "js-cookie";
import wretch from 'wretch'
import { API_URL } from "../constraints";

const strapi = wretch(`${API_URL}/api`)
if (Cookie.get('AUTH_TOKEN')) {
    strapi.auth(Cookie.get('AUTH_TOKEN') as string)
}

export default strapi